import { render, staticRenderFns } from "./LeonidaArchivioVisiteList.vue?vue&type=template&id=4b7cacf4"
import script from "./LeonidaArchivioVisiteList.vue?vue&type=script&lang=js"
export * from "./LeonidaArchivioVisiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports